<nb-layout>

  <nb-layout-header>
    <div>
      <img src="../assets/images/logo_64.png" style="width: 32px;">
      {{subdomain || ''}}
    </div>
    <button nbButton size="small" status="primary" *ngIf="showBtnCloseSession" (click)="closeSession()">Cerrar sesión</button>
  </nb-layout-header>

  <nb-layout-column class="py-0 py-md-4 py-lg-6 px-0 px-md-4 px-lg-6" >
    <router-outlet></router-outlet>
  </nb-layout-column>

  <nb-layout-footer fixed>
  <a href="https://www.sistemabravo.com.ar" target="_blank">BRAVO</a>&nbsp;- 2026 v3.3 -&nbsp;<a href="https://sistema-bravo.blogspot.com/" target="_blank">Blog</a>
  </nb-layout-footer>

</nb-layout>
